import { Text, YStack } from 'tamagui'
import { useApp } from '../../i18n'
import type { Employment } from '../../lib/types'
import { employmentLabel } from '../edo/forms/EmploymentField'
import { EmploymentRequisites, employmentTypeText } from './EmploymentRequisites'
export function EmploymentList({ jobs, conflict }: { jobs?: Employment[]; conflict?: boolean }) {
  const { t } = useApp()
  const active = (jobs ?? []).filter(job => job.status === 'ACTIVE')
  if (!active.length && !conflict) return null
  return <YStack gap={8} marginVertical={12}>
    <Text fontSize={13} fontWeight="700">{t({ ru: 'Места работы', az: 'İş yerləri', en: 'Workplaces' })}</Text>
    {active.map(job => <YStack key={job.id} gap={3}>
      <Text fontSize={13}>{employmentLabel(job)}</Text>
      <Text fontSize={11} color="$muted">{[job.department, employmentTypeText(job, t)].filter(Boolean).join(' · ')}</Text>
      <EmploymentRequisites job={job} />
      {job.isPrimary && <Text fontSize={11} color="$primary">{t({ ru: 'Основное', az: 'Əsas', en: 'Primary' })}</Text>}
    </YStack>)}
    {conflict && <Text fontSize={12} color="$muted">{t({ ru: 'Основное место работы не определено. Для заявок выберите место работы; HR может уточнить основное.', az: 'Əsas iş yeri müəyyən edilməyib. Ərizə üçün iş yerini seçin.', en: 'The primary workplace is unresolved. Choose a workplace for requests; HR can clarify the primary.' })}</Text>}
  </YStack>
}
